/**
 * @generated SignedSource<<d6b395ac4e55fe131146f2b294b922ea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FollowTopicInput = {
  topicSlug: string;
};
export type PodcastPageFollowMutation$variables = {
  input: FollowTopicInput;
};
export type PodcastPageFollowMutation$data = {
  readonly followTopic: {
    readonly topic: {
      readonly followerCount: number;
      readonly id: string;
      readonly isFollowedByViewer: boolean | null | undefined;
    } | null | undefined;
    readonly userErrors: ReadonlyArray<{
      readonly field: string | null | undefined;
      readonly message: string;
    }>;
  };
};
export type PodcastPageFollowMutation = {
  response: PodcastPageFollowMutation$data;
  variables: PodcastPageFollowMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "FollowTopicPayload",
    "kind": "LinkedField",
    "name": "followTopic",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Topic",
        "kind": "LinkedField",
        "name": "topic",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isFollowedByViewer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "followerCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "userErrors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PodcastPageFollowMutation",
    "selections": (v1/*: any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PodcastPageFollowMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d7a2d4e80ca4969375d9f3b6aca8bd40",
    "id": null,
    "metadata": {},
    "name": "PodcastPageFollowMutation",
    "operationKind": "mutation",
    "text": "mutation PodcastPageFollowMutation(\n  $input: FollowTopicInput!\n) {\n  followTopic(input: $input) {\n    topic {\n      id\n      isFollowedByViewer\n      followerCount\n    }\n    userErrors {\n      message\n      field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e0306e8276745577c6eff1a6dea3c5e4";

export default node;
